module.exports = __webpack_public_path__ + "static/media/store6.186184e2.jpg";